import { compareItems, type RankingInfo } from '@tanstack/match-sorter-utils'
import { type Row, sortingFns } from '@tanstack/react-table'
import type { DataTableRow, DataTableRowData } from '../types'

const fuzzy = <TData extends DataTableRowData>(
  rowA: Row<TData>,
  rowB: Row<TData>,
  columnId: string,
) => {
  let dir = 0
  if (rowA.columnFiltersMeta[columnId]) {
    dir = compareItems(
      rowA.columnFiltersMeta[columnId] as RankingInfo,
      rowB.columnFiltersMeta[columnId] as RankingInfo,
    )
  }
  // Provide a fallback for when the item ranks are equal
  return dir === 0
    ? sortingFns.alphanumeric(rowA as Row<unknown>, rowB as Row<unknown>, columnId)
    : dir
}

export const DataTableSortingFns = {
  ...sortingFns,
  fuzzy,
}

export const rankGlobalFuzzy = <TData extends DataTableRowData>(
  rowA: DataTableRow<TData>,
  rowB: DataTableRow<TData>,
) =>
  // biome-ignore lint/suspicious/noExplicitAny: TODO - fix type definition
  Math.max(...Object.values(rowB.columnFiltersMeta).map((v: any) => v.rank)) -
  // biome-ignore lint/suspicious/noExplicitAny: TODO - fix type definition
  Math.max(...Object.values(rowA.columnFiltersMeta).map((v: any) => v.rank))
